export class CharacterizeTestedPartyOptionTypeErrorResponse {
  'typeOfPrimaryFunctionOption.typeOfPrimaryFunctionOptionId': any;
  'codeType.codeTypeId': any;
  'industrialCodeValue.industrialCodeValueId': any;
}
